var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreUseCases({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 14.8333,
    fill: "#F0EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.3125C30.3467 20.3125 26.5625 24.0979 26.5625 28.75C26.5625 29.2676 26.9824 29.6875 27.5 29.6875C28.0176 29.6875 28.4375 29.2676 28.4375 28.75C28.4375 25.1318 31.3818 22.1875 35 22.1875C35.5176 22.1875 35.9375 21.7676 35.9375 21.25C35.9375 20.7324 35.5176 20.3125 35 20.3125Z",
    fill: "#4B1498"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.3125C27.5903 15.3125 21.5625 21.3403 21.5625 28.75C21.5625 34.2517 23.877 37.262 25.7373 39.6802C26.897 41.1877 27.8125 42.3792 27.8125 43.75V48.75C27.8125 52.0239 30.4761 54.6875 33.75 54.6875H36.25C39.5239 54.6875 42.1875 52.0239 42.1875 48.75V43.75C42.1875 42.3792 43.103 41.1877 44.2627 39.6802C46.123 37.262 48.4375 34.2517 48.4375 28.75C48.4375 21.3403 42.4097 15.3125 35 15.3125ZM40.3125 44.6875V47.8125H29.6875V44.6875H40.3125ZM36.25 52.8125H33.75C31.833 52.8125 30.233 51.4752 29.8074 49.6875H40.1926C39.767 51.4752 38.167 52.8125 36.25 52.8125ZM42.7759 38.5376C41.7165 39.9146 40.7506 41.2444 40.448 42.8125H29.552C29.2494 41.2444 28.2835 39.9146 27.2241 38.5376C25.4492 36.2292 23.4375 33.6145 23.4375 28.75C23.4375 22.3743 28.6255 17.1875 35 17.1875C41.3745 17.1875 46.5625 22.3743 46.5625 28.75C46.5625 33.6145 44.5508 36.2292 42.7759 38.5376Z",
    fill: "#4B1498"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreUseCases);
export default __webpack_public_path__ + "static/media/explore-use-cases.fea1c05447467cfbbe082e3e91f3f83e.svg";
export { ForwardRef as ReactComponent };